<app-not-applicable-label *ngIf="!firstValue" [tooltipDynamicText]="toolTip"> </app-not-applicable-label>

<div *ngIf="firstValue" class="multi-value-container">
  <span class="first-value">{{ firstValue }}</span>

  <app-additional-values
    *ngIf="additionalValues.length > 0"
    [additionalValues]="additionalValues"
    [includePaddingInMinWidth]="true"
  >
  </app-additional-values>
</div>
